"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icone = exports.iconesMu = void 0;
var react_1 = __importStar(require("react"));
var Cores_1 = require("../Cores/Cores");
var Acoes_1 = __importDefault(require("./Categorias/Acoes"));
var Construcao_1 = __importDefault(require("./Categorias/Construcao"));
var Avisos_1 = __importDefault(require("./Categorias/Avisos"));
var Navegacao_1 = __importDefault(require("./Categorias/Navegacao"));
var Setas_1 = __importDefault(require("./Categorias/Setas"));
var Usuarios_1 = __importDefault(require("./Categorias/Usuarios"));
var Vendas_1 = __importDefault(require("./Categorias/Vendas"));
var Condicional_1 = __importDefault(require("../../assets/icons/condicional/Condicional"));
var ArquivosEDados_1 = __importDefault(require("./Categorias/ArquivosEDados"));
var DataEhora_1 = __importDefault(require("./Categorias/DataEhora"));
var Formatacao_1 = __importDefault(require("./Categorias/Formatacao"));
exports.iconesMu = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, Acoes_1.default), Avisos_1.default), Navegacao_1.default), Setas_1.default), Usuarios_1.default), Construcao_1.default), Vendas_1.default), Condicional_1.default), ArquivosEDados_1.default), DataEhora_1.default), Formatacao_1.default);
var Icone = function (_a) {
    var _b = _a.nome, nome = _b === void 0 ? "info" : _b, _c = _a.cor, cor = _c === void 0 ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 : _c, corOnHover = _a.corOnHover, _d = _a.altura, altura = _d === void 0 ? "24px" : _d, _e = _a.largura, largura = _e === void 0 ? "24px" : _e, _f = _a.desabilitado, disabled = _f === void 0 ? false : _f, style = _a.style, className = _a.className;
    var _g = (0, react_1.useState)(false), isHovered = _g[0], setIsHovered = _g[1];
    var corFinal = isHovered && corOnHover
        ? corOnHover
        : cor !== null && cor !== void 0 ? cor : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600;
    var ComponenteIcone = exports.iconesMu[nome];
    if (!ComponenteIcone) {
        return null;
    }
    return (react_1.default.createElement(ComponenteIcone, { fill: disabled ? Cores_1.Cores.GradacaoNeutros.CinzaFillMU400 : corFinal, width: largura, height: altura, style: style, className: className, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } }));
};
exports.Icone = Icone;
